export default function getPermittedLanguages(pageData) {
  // return the documentation_language keys as Array

  const { documentationLanguages } = pageData;
  if(!documentationLanguages) return [];

  const keysArray = Object.entries(documentationLanguages)
    .filter(array => !array[1].ignore_from_language_selector)
    .map(([key]) => key);

  return keysArray;
}
